import React, {useState, useEffect, useContext} from 'react';
import {ConfigContext} from './ConfigContextProvider';
import {LocaleContext} from './LocaleContextProvider';

export const AuthenticationContext = React.createContext();

const AuthenticationContextProvider = props => {
  const [userOptions, setUserOptions] = useState(null);
  const [apps, setApps] = useState(null);
  const [navigation, setNavigation] = useState(null);
  const [favorites, setFavorites] = useState([]);
  const {locale} = useContext(LocaleContext);

  const {SETUP_URL} = useContext(ConfigContext);
  const {USEROPTIONS_URL} = useContext(ConfigContext);
  const {MODE} = useContext(ConfigContext);
  const {APPID} = useContext(ConfigContext);

    const store = {
      userOptions: userOptions,
      apps: apps,
      favorites: favorites,
      setFavorites: setFavorites,
      navigation: navigation
    }
    // document.addEventListener('checkSession',  (e) => { 
    //     console.log("logged", e);
    //     setUserOptions(e.detail)
    //     //setLoginIsOpen(true);
    // }, false);

    const loadNavigation= (url) => {
      fetch(url)
        .then(res => res.json())
        .then(
          (result) => {
            setNavigation(result)
          },
          (error) => {
          }
      )
    }
    const loadUserOptions = () => {
        const param= {  appid: APPID, lang: locale, ssid: localStorage.getItem('ssid')};

        let formData = new FormData();
        for(var i in param){
          formData.append(i,param[i]);
        }

        const options= {
          method: 'POST',
          body: formData
        };

        //fetch(USEROPTIONS_URL, (MODE=="dev") ? {} : options )
        fetch(USEROPTIONS_URL, options )
        .then(res => res.json())
        .then(
          (result) => {
            setUserOptions(result.settings)
            setApps(result.apps || {})
            if(!result.settings.navigation) {
              loadNavigation(SETUP_URL)
            } else {
              setNavigation(result.settings.navigation)
            }
          },
          (error) => {
              console.log("--> error")
          }
        )
    }

    useEffect(() => {
        //updta favorites
        var favoritesObject = JSON.parse(localStorage.getItem('favorites'));
        if(favoritesObject) {
          setFavorites(favoritesObject)
        }
        loadUserOptions()

        // dopo login/registrazione l'evento porta solo i settings:
        // ricarichiamo anche le apps (permessi, es. samples.request) per il nuovo utente
        const onUpdateUserOption = (e) => {
          setUserOptions(e.detail)
          loadUserOptions()
        }
        document.addEventListener('updateUserOption', onUpdateUserOption, false);
        return () => document.removeEventListener('updateUserOption', onUpdateUserOption, false);
        }, []);

    return (
        <AuthenticationContext.Provider value={store}>
            {userOptions && apps && navigation && props.children}
        </AuthenticationContext.Provider>
    );
};

export default AuthenticationContextProvider